module.exports = __webpack_public_path__ + "img/eu-2.6c0e2685.jpg";